import { jsxs as p, Fragment as b, jsx as t } from "react/jsx-runtime";
import { forwardRef as j, useState as F } from "react";
import { attributes as S } from "../utils/attributes.js";
import { classnames as o } from "../utils/classnames.js";
import { SimpleText as T } from "../SimpleText/SimpleText.js";
import '../../assets/Input.css';const R = j(
  ({
    id: a,
    label: n,
    helper: l,
    style: u,
    Icon: i,
    inputClassName: d,
    disabled: s = !1,
    onChange: r,
    mode: f,
    isInvalid: e = !1,
    ...h
  }, v) => {
    const [m, x] = F(e), N = (c) => {
      f === "auto" && x(c.currentTarget.checkValidity() !== !0), r == null || r(c);
    };
    return /* @__PURE__ */ p(b, { children: [
      n && /* @__PURE__ */ t("label", { className: "input-label", htmlFor: a, children: n }),
      /* @__PURE__ */ p("div", { className: o(["input-icon", !!i]), children: [
        i && /* @__PURE__ */ t("div", { className: "input-iconElement", children: /* @__PURE__ */ t(i, {}) }),
        /* @__PURE__ */ t(
          "input",
          {
            id: a,
            ref: v,
            className: o(
              ["input"],
              ["input--invalid", m || e],
              ["input-icon-input", !!i],
              [d || ""]
            ),
            onChange: N,
            style: u,
            ...S({
              disabled: s,
              "aria-disabled": s
            }),
            ...h
          }
        )
      ] }),
      l && /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
        T,
        {
          className: "input-helper-text",
          variant: m || e ? "error" : "light",
          children: l
        }
      ) })
    ] });
  }
);
export {
  R as Input
};
//# sourceMappingURL=Input.js.map
